var _excluded = ["forceNewTab", "to"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*eslint-disable jsx-a11y/anchor-has-content*/
import React from 'react';
import { Link } from "react-router-dom";
import { useFeatureValue } from "@growthbook/growthbook-react";
import { resourceUrl } from "@magento/venia-ui/lib/drivers";
import { getStoreCode } from "../StoreCodeRoute/storeCodeRoute";
import { getBuildVersion } from "../App/app";
export var isLinkExternal = link => {
  return link && (link.includes('https:') || link.includes('http:') || link.includes("www.") || link.includes("tel:"));
};
var removeFirstSlash = href => {
  if (href.charAt(0) === "/") {
    return href.substring(1);
  }
  return href;
};
var BBLink = props => {
  var {
      forceNewTab,
      to
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var resolvedLink = resourceUrl(to);
  var isExternal = isLinkExternal(resolvedLink);
  var deployment_version = useFeatureValue('deployment_version');
  var cache_version = process.env.CACHE_VERSION;
  var isDevelopment = process.env.NODE_ENV === 'development';
  var isNewVersion = !isDevelopment && getBuildVersion(deployment_version) > getBuildVersion(cache_version);
  var loadExternalLink = () => {
    var href = removeFirstSlash(resolvedLink);
    return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
      target: "_blank",
      href: href
    }));
  };
  var loadNewVersionLink = () => {
    var storeCode = getStoreCode();
    var href = removeFirstSlash(resolvedLink);
    if (!href.startsWith(storeCode)) {
      href = "/".concat(storeCode, "/") + href;
    }
    return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
      target: "_self",
      href: href
    }));
  };
  return isExternal || forceNewTab ? loadExternalLink() : isNewVersion ? loadNewVersionLink() : /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
    to: resolvedLink
  }));
};
export default BBLink;